import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-down-arrow-white",
  "use": "icon-down-arrow-white-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 12\" id=\"icon-down-arrow-white\"><path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-opacity=\".85\" stroke-width=\"1.125\" d=\"m3 6.75 3 3 3-3M3 3l3 3 3-3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol